import React, { useContext, useState } from "react";
import { FiMail, FiX } from "react-icons/fi";
import { AuthContext } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { resendVerificationEmail } from "../../api/auth";

export default function VerifyEmailBanner() {
  const { user } = useContext(AuthContext);
  const { notify } = useToast();
  const [dismissed, setDismissed] = useState(sessionStorage.getItem("verifyBannerDismissed") === "true");
  const [sending, setSending] = useState(false);

  if (!user || user.emailVerified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerificationEmail();
      notify("Verification email sent — check your inbox.", "success");
    } catch {
      notify("Couldn't send the verification email. Try again shortly.", "error");
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem("verifyBannerDismissed", "true");
    setDismissed(true);
  };

  return (
    <div className="flex items-center gap-3 border-b border-amber-100 bg-amber-50 px-4 py-2.5 text-sm text-amber-800 sm:px-6">
      <FiMail className="h-4 w-4 shrink-0" />
      <p className="flex-1">
        Please verify your email address ({user.email}).
      </p>
      <button
        onClick={handleResend}
        disabled={sending}
        className="shrink-0 font-medium text-amber-900 underline hover:text-amber-950 disabled:opacity-60"
      >
        {sending ? "Sending…" : "Resend email"}
      </button>
      <button onClick={handleDismiss} className="shrink-0 text-amber-400 hover:text-amber-600" aria-label="Dismiss">
        <FiX className="h-4 w-4" />
      </button>
    </div>
  );
}
